export default "__VITE_ASSET__BIDV2ZWl__"